import { TFunction } from 'i18next';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { CSSProperties } from 'react';
import { StylesConfig } from 'react-select';

import { IColor, IForecastGroupData, IMaterialGroupData, INewsGroupData, IPdfModuleGroupData } from 'features/admin/interface/admin';
import { ISpanMapper } from 'features/dashboard/interface/dashboard';
import { IStrokeColors } from 'features/futuretable/interface/futureTable';
import { IKebabMenuList } from 'features/material/interface/material';
import localizationConstants from 'shared/util/translation/constants';
import { IDropDownOption, IRadioButtonArray, QueryParameters } from '../interface';
import { MaterialMenuIcon, NewsMenuIcon, TenderMenuIcon, TenderAlerTabIcon, Props, DEFlagIcon, UKFlagIcon } from 'shared/icons/icon';
import { RadioOption } from 'shared/components/form/radioButton';
//import { IPdfModuleFiles } from "../../features/pdfModule/interface/pdfModule";

const firstLevelBreadcrumbs = [{ name: 'Home', link: '/' }];
// const { t } = i18n;
const API_CONFIG = {
	baseUrl: `${process.env.REACT_APP_BASE_URL}`,
	path: {
		addAlertToDashboard: 'dashboard/AlertToDashboard',
		readAlerts: 'course/alerts/update_alerts_read',
		getTotalUserCounts: 'admin/analytics/get_active_user',
		getAnalyticsDashboardData: 'report/dashboard-graph-statistics',
		getUserStatisticsSessions: 'report/user-sessions-statistics',
		getUserSessions: 'report/user-sessions',
		getActiveUserCounts: 'report/active-users-counts',
		userPageVisitAnalytics: 'tracks/page-visits',
		userSessionAnalytics: 'tracks/session',
		getAnimateNesWidget: 'user/profile/dashboard_widgets_view',
		getShowPartnerLink: 'user/profile/show_partner_section',
		savePersonalizeData: 'user/profile/personlization',
		getPersonalizeData: 'user/profile/user_personlization',
		getPartnerLink: 'dashboard/partner_link',
		whitelabelDeleteNewsList: 'admin/whitelabel/news/delete-list',
		userWhitelabelAllNews: 'whitelabel/all_news',
		adminNewsRenameList: 'admin/news/rename_list',
		supportRequest: 'shared/support-request',
		whitelabelNewsGroupVisibility: 'admin/news/group-visibility',
		whitelabelNewsListVisibility: 'admin/whitelabel/news/list-visibility',
		whitelabelNewsGroupVisiblity: 'admin/whitelabel/news/group-visibility',
		whitelabelNewsListDragAndDrop: 'admin/whitelabel/news/drag-drop-materials-list',
		whitelabelNewsGroupDragAndDrop: 'admin/whitelabel/news/drag-drop-group',
		deleteWhitelabelNewsGroup: 'admin/whitelabel/news/delete-group',
		updateWhitelabelNewsGroup: 'admin/whitelabel/news/update-group',
		createWhitelabelNewsGroup: 'admin/whitelabel/news/create-group',
		getWhitelabelNewsGroupDetail: 'admin/whitelabel/news/detail/group',
		whitelabelNewsStructure: 'admin/whitelabel/all_news',
		userWhitelabelMaterialList: 'whitelabel/lists',
		userWhitelabelAllMaterials: 'whitelabel/all_materials',
		materialListVisiblity: 'admin/material/list_visibility',
		whitelabelListVisibility: 'admin/whitelabel/list-visibility',
		materialGroupVisiblity: 'admin/material/group_visibility',
		whitelabelGroupVisiblity: 'admin/whitelabel/group-visibility',
		updateWhitelableMaterialVisiblity: 'admin/whitelabel/change_visibility_material',
		deleteWhitelabelGroup: 'admin/whitelabel/material/delete-group',
		deleteWhitelabelList: 'admin/whitelabel/material/delete-material-list',
		deleteWhitelabelListEntries: 'admin/whitelabel/material/delete-list-entries',
		addWhitelabelMaterialList: 'admin/whitelabel/add-material-list',
		updateWhitelabelMaterialList: 'admin/whitelabel/update-material-list',
		updateWhitelabelGroup: 'admin/whitelabel/update-group',
		fetchWhitelabelGroupDetails: 'admin/whitelabel/detail/group',
		whitelabelCreateNewGroup: 'admin/whitelabel/create-group',
		whitelabelDataDragandDropMaterialList: 'admin/whitelabel/drag-drop-materials-list',
		whitelabelDataDragandDropMaterialListEntries: 'admin/whitelabel/drag-drop-materials-list-entries',
		whitelabelDataDragandDropMaterialGroup: 'admin/whitelabel/drag-drop-group',
		sharedSlackError: 'shared/slack_error',
		tenderFinancer: 'tenders/all/financers',
		exportCourseHistoryNew: 'download/chartDataV2',
		adminDownloadIntrdayData: 'course/intraday/download',
		getChartData4: 'course/courseHistoryV5',
		getChartData6: 'course/courseHistoryV6',
		getChartData6Batch: 'course/courseHistoryV6Batch',
		chartAvailability: 'materials/chart_avabilities',
		advanceSettingView: 'materials/advance_setting_view',
		isNewsFavourite: 'news/isfavourite',
		assignBackpack: 'admin/backpack/course',
		backpackMassValidity: 'admin/backpack/courseandcourselist',
		materialMassValidity: 'admin/permissions/massvalidity',
		maintenance: 'shared/maintenance',
		whitelabelPublicConfig: 'auth/whitelabel/public-config',
		deleteFromDashboard: 'costmodel/delete_from_dashboard',
		updateHistoryData: 'course/updateHistoryData',
		getMyMatflixxModals: 'costmodel/visible/model_list',
		costModelDetails: 'costmodel/all_charts',
		getProductDetails: 'costmodel/list_product_details',
		uploadCostModelImage: 'costmodel/upload/cost/modal',
		createCostModel: 'costmodel/create',
		getCostModelList: 'costmodel/model_list',
		getCostModelChart: 'costmodel/chart',
		costModelUpdateView: 'costmodel/update_view',
		getCostModelTableData: 'costmodel/table',
		getDoughnutChartData: 'costmodel/pie_chart',
		getModalDetails: 'costmodel/model_details',
		updateCostModel: 'costmodel',
		costModelDragAndDrop: 'costmodel/drag_drop/change',
		costModelTableRange: 'costmodel/table_by_date',
		login: 'auth/login',
		ssoLogin: 'auth/sso/login',
		ssoExchange: 'auth/sso/exchange',
		user: 'user',
		permission: 'permission',
		logout: 'auth/logout',
		forgetPassword: 'password/forgot',
		resetPassword: 'auth/password/reset',
		profile: 'user/profile',
		changePassword: 'password/change_password',
		globalSearch: 'global/search/get-material-search',
		materialSearch: 'global/search/material_search',
		newsSearch: 'global/search/news_search',
		dashboard: 'dashboard',
		deleteDashboardElement: 'dashboard',
		materialNav: 'materials',
		courseList: 'materials/lists',
		myMaterialCourseList: 'materials/lists',
		futuretable: 'course/furute-table-lists',
		addFutureTableToDashboard: 'dashboard/addFutureTableToDashboard',
		addCourseListToDashboard: 'dashboard/addCourseListToDashboard',
		deleteMyMaterialCourseList: 'course/me/courseitem',
		exportFutureTableXLS: 'course/exportFutureTableXLS',
		getChartData: 'course/courseHistory',
		getChartDataV2: 'course/courseHistoryV2',
		setMaterialAlert: 'course/alerts/set-alerts-materials',
		newsArticle: 'news',
		newsArticleV2: 'news/listv2',
		saveNewsList: 'news/me',
		saveNews: 'news/favourite',
		allNewsCategories: 'news/menu/new',
		newsCategoryDropdown: 'news/dropdown/list',
		optionsCategory: 'news/options/categories',
		addNewsToDashboard: 'dashboard/addNewsDashboard',
		allMaterialData: 'materials/all_materials',
		getMaterialSearchWord: 'materials/search/word',
		courseListDropDown: 'materials/drop-down/list',
		addWidgetData: 'dashboard/selection_data',
		addMaterialToDashboard: 'dashboard/add_multiple_items',
		addChartToDashboard: 'dashboard/addChartToDashboard',
		saveMaterial: 'materials/save/material',
		allMaterialCourseLists: 'materials/all_lists',
		myMaterialList: 'course/me',
		allMaterialAlertList: 'course/alerts/get-alerts-materials',
		allNewsAlertList: 'course/alerts/get-alerts-news',
		setNewsAlert: 'course/alerts/set-alerts-news',
		deleteMaterialAlert: 'course/alerts/delete-alerts-materials',
		deleteNewsAlert: 'course/alerts/delete-alerts-news',
		updateNewsAlert: 'course/alerts/update-alerts-news',
		updateMaterialAlert: 'course/alerts/update-alerts-materials',
		addShortcut: 'dashboard/add-link-dashboard',
		exportCourseHistory: 'course/downloadCourseHistoryNew',
		exportStandardExcel: 'download/chartdata',
		addAdvanceChartImage: 'download/chartData',
		editShortcut: 'dashboard/update-link-dashboard',
		userList: 'admin/users',
		alertBaseCount: 'course/alerts/get-base-alerts',
		forecastList: 'forecast/list',
		pdfModuleList: 'pdfModule/list',
		forecastDetails: 'forecast/list/detail',
		pdfModuleDetails: 'pdfModule/list/detail',
		adminMaterialList: 'admin/permissions/courselist',
		currencyList: 'materials/list/currency',
		countryList: 'materials/lists/countries',
		adminMaterialSearch: 'admin/material/search/word',
		authorizeMaterialGroup: 'admin/permissions/courselist',
		courseAuthorization: 'admin/permissions/course',
		adminNewsList: 'admin/permissions/newsList',
		newsAuthorization: 'admin/permissions/newsList',
		adminForecastList: 'admin/permissions/foreCast',
		adminPdfModuleList: 'admin/permissions/pdfModule',
		assignMaterialToAdmin: 'admin/permissions/course',
		forecastAuthorization: 'admin/permissions/forecastList',
		pdfModuleAuthorization: 'admin/permissions/pdfModuleList',
		updateUser: 'admin/users/update',
		uploads: 'admin/uploads/excel',
		register: 'register',
		updateNews: 'admin/news/update',
		deleteNews: 'admin/news/delete',
		mbiListDropdown: 'admin/material/drop-down-mbi-material-list',
		addMBIList: 'admin/material/add-mbi-material-list',
		adminHistoryDownload: 'admin/material/history',
		adminMaterialData: 'admin/material/all_materials',
		adminUpdateMaterial: 'admin/material/update-material-list',
		adminDeleteMaterial: 'admin/material/delete-material-list',
		adminDropdownMaterialList: 'admin/material/drop-down-material-list',
		adminListEntries: 'admin/material/list_entries',
		adminChangeMaterialList: 'admin/material/change-material-list',
		partner: 'admin/partner',
		getAdminUsers: 'admin/users',
		addPartnerLink: 'admin/partner',
		deletePartnerLink: 'admin/partner',
		updatePartnerLink: 'admin/partner/update',
		createPassword: 'password/reset',
		updateService: 'auth/update-service',
		statusChange: 'auth/status/islogin',
		getAdminForecastList: 'admin/forecast/box/list',
		getAdminPdfModuleList: 'admin/pdfModule/box/list',
		getForecastCategories: 'admin/forecast/cateogries',
		getPdfModuleCategories: 'admin/pdfModule/cateogries',
		uploadForecast: 'admin/forecast/upload',
		uploadPdfModule: 'admin/pdfModule/upload',
		forcastDownload: 'forecast/download',
		pdfModuleDownload: 'pdfModule/download',
		changeViewForNews: 'dashboard/changeViewForNews',
		deleteListEntries: 'admin/material/delete-list-entries',
		automaticDashboard: 'dashboard/blankDashboard',
		markAsAllRead: 'course/alerts/update_alerts_read',
		updateLanguage: 'user/profile/update_language',
		getProtocolList: 'admin/tables/protokoll-list',
		adminCategory: 'admin/material/pricelist',
		adminApiList: 'admin/permissions/material',
		adminApiPermission: 'admin/permissions/courselist/individual',
		adminApiMasterDataDownload: 'admin/permissions/courselist/download',
		xApiFileDownload: 'admin/tables/quotes/api',
		downloadMyMaterialAdminKurs: 'admin/material/download/lists',
		adminTableDownload: 'admin/tables/download',
		takeOverAccount: 'admin/users/takeover',
		returnTakeOver: 'admin/users/return-take-over',
		getMaterialDetails: 'course/alerts/get_details_materials',
		addBackpack: 'admin/backpack',
		addChartInformation: 'admin/material/add_info_chart',
		adminAllMaterialList: 'admin/material/all_materials_list',
		adminAllMaterialListPage: 'admin/material/all_materials_list_page',
		adminDataDragandDrop: 'admin/material/drag_drop_materials_list',
		adminDragAndDropList: 'admin/material/drag_drop_list',
		adminDragAndDropgroup: 'admin/material/drag_drop_group',
		fetchBackpackMaterials: 'admin/backpack/materials',
		authorizeBackpackMaterialGroup: 'admin/backpack/courselist',
		backpackCourseAuthorization: 'admin/backpack/course',
		fetchBackpackNews: 'admin/backpack/newsList',
		fetchBackpackForecast: 'admin/backpack/foreCast',
		fetchBackpackPdfModule: 'admin/backpack/pdfModule',
		newsBackpackAuthorization: 'admin/backpack/newsList',
		forecastBackpackAuthorization: 'admin/backpack/forecastList',
		pdfModuleBackpackAuthorization: 'admin/backpack/pdfModuleList',
		getBackpackList: 'admin/backpack/list',
		adminBackpackPermission: 'admin/backpack/backpack_user',
		backpackUserList: 'admin/backpack/users',
		renameMaterialList: 'admin/material/rename_material_list',
		deleteMaterialList: 'admin/material/delete_material_list',
		exportAdminCourseListEntries: 'admin/material/download/lists',
		exportAdminMasterData: 'admin/material/master',
		getWhiteLabelGroups: 'admin/whitelabel/groups',
		whiteLabelUserList: 'admin/whitelabel/users_dropdown',
		addWhiteLabelGroup: 'admin/whitelabel/add_whitelabe_group',
		uploadWhiteLabelLogo: 'admin/whitelabel/upload',
		updateWhiteLabelGroup: 'admin/whitelabel/update_whitelabe_group',
		updateWhitelabelConfig: 'admin/whitelabel/update_whitelabe_config',
		addMaterialList: 'admin/permissions/addMaterialList',
		updateDateFormat: 'user/profile/update-date-formate',
		deleteWhiteLabelGroup: 'admin/whitelabel',
		fetchWhiteLabelGroup: 'costmodel/group_list',
		fetchCostModelList: 'costmodel/group_model',
		addModalToDashboard: 'costmodel/add_to_dashboard',
		updateMaterialAlertCount: 'course/alerts/update-alerts-materials-count',
		fetchGroupDropDownData: 'admin/material/dropdown/group_list',
		uploadGroupImage: 'shared/upload/group/image',
		createNewGroup: 'admin/material/create_group',
		deleteGroup: 'admin/material/delete_group',
		updateGroupName: 'admin/material/update_group',
		fetchMaterialGroupDetails: 'admin/material/detail/group',
		updateMaterialVisibility: 'admin/material/change_visibility_material',
		addMatfoxxOffers: 'matfoxx/add_offers_matfoxx',
		fetchMatfoxxOffers: 'matfoxx/get_offers_matfoxx',
		deleteMatfoxxOffers: 'matfoxx/delete-matfoxx-offer',
		addMatfoxxJokes: 'matfoxx/add_joke_matfoxx',
		fetchMatfoxxJokes: 'matfoxx/get_joke_matfoxx',
		deleteMatfoxxJokes: 'matfoxx/delete-matfoxx-joke',
		updateMatfoxxUserConfig: 'matfoxx/update_notification_matfoxx',
		getUserLoginTime: 'matfoxx/get_login_time',
		fetchMatfoxxData: 'matfoxx/notification_offer_joke_matfoxx',
		updateMatfoxxView: 'matfoxx/update_notification_view_matfoxx',
		fetchForecastGroupData: 'admin/forecast/group_list',
		fetchPdfModuleGroupData: 'admin/pdfModule/group_list',
		uploadForecastGroupImage: 'admin/forecast/upload/forecast',
		uploadPdfModuleGroupImage: 'admin/pdfModule/upload/pdf',
		createForecastGroup: 'admin/forecast/create_group',
		createPdfModuleGroup: 'admin/pdfmodule/create_group',
		uploadAdminCostModelImage: 'admin/costmodel/upload/cost/modal',
		createCostModelGroup: 'admin/costmodel/create_group',
		getCostModelData: 'admin/costmodel/group/model',
		costModelVisibility: 'admin/costmodel/update_visibility',
		deleteCostModelGroup: 'admin/costmodel/delete_group',
		deleteCostModel: 'admin/costmodel/delete_costmodel',
		renameCostModel: 'admin/costmodel/update_costmodel_name',
		renameCostModelGroup: 'admin/costmodel/update_group',
		adminCostModelDragAndDrop: 'admin/costmodel/drag_drop_costmodel',
		deleteForecastGroup: 'admin/forecast/delete_group',
		deletePdfModuleGroup: 'admin/pdfModule/delete_group',
		changeForecastGroupVisibility: 'admin/forecast/update_visibility',
		changePdfModuleGroupVisibility: 'admin/pdfModule/update_visibility',
		getForecastGroupDetail: 'admin/forecast/detail/group',
		getPdfModuleGroupDetail: 'admin/pdfModule/detail/group',
		updateForecastGroup: 'admin/forecast/update_group_subgroup',
		updatePdfModuleGroup: 'admin/pdfModule/update_group_subgroup',
		fetchAdminNewsData: 'admin/news',
		adminAllNewsCategoriesList: 'admin/news/all_news_categories',
		newsGroupDragAndDrop: 'admin/news/drag_drop_sub_group',
		newsListDragAndDrop: 'admin/news/drag_drop_list',
		adminNewsGroupDropDownList: 'admin/news/all_groups',
		createNewsGroup: 'admin/news/create_group',
		deleteNewsGroup: 'admin/news/delete_group',
		deleteNewsList: 'admin/news/delete_categories',
		newsListVisibility: 'admin/news/list_visibility',
		getAdminNewsDetail: 'admin/news/detail/news/group',
		updateNewsGroup: 'admin/news/update_group',
		deleteNewsCategory: 'admin/news/delete_list',
		addAnnouncements: 'announcement/add_announcement',
		fetchAnnouncementsList: 'announcement/get_announcement',
		deleteAnnouncementsList: 'announcement/delete_announcement',
		getAnnouncements: 'announcement/get_all',
		deleteForecastFile: 'admin/forecast/delete/pdf',
		deletePdfModuleFile: 'admin/pdfModule/delete/pdf',
		downloadBackpackMasterData: 'admin/backpack/master',
		adminBackpackApiList: 'admin/backpack/individual/material',
		chartInformation: 'materials/chart_information',
		getUnitData: 'course/unitConvter',
		getHistoryDropDown: 'materials/data_available_year',
		adminForecastDownload: 'admin/material/forecast/history',
		adminPdfModuleDownload: 'admin/material/pdfModule/history',
		uploadSVGIcon: 'shared/upload/group/svg',
		allContinents: 'tenders/all/continent',
		allTenderSectors: 'tenders/all/sectors',
		allTendersList: 'tenders/list',
		bookmarkTender: 'tenders/bookmark',
		tenderFullArticle: 'tenders',
		addTendersToDashboard: 'dashboard/addTendersToDashboard',
		tenderAlerts: 'tenders/alert',
		getAdminTenderDetail: 'admin/permissions/tender',
		getBackpackTenderDetail: 'admin/backpack/tender',
		addAdvanceChartConfig: 'download/masterChartData',
		getChartMasterData: 'download/masterChartData',
		getBackpackGroupList: 'admin/group/all-list',
		createGroupConfig: 'admin/group/create-group',
		getGroupList: 'admin/group/get-all-group',
		deleteGroupList: 'admin/group/delete-group',
		updateGroupList: 'admin/group/update-group',
		getGroupUserDetails: 'admin/group/user-details',
		assignGroupToUser: 'admin/group/manage-user-to-group',
		getUserList: 'admin/group/list-all-user',
		getDashboardIFrameData: 'iframe',
		getIFrameChartData: 'iframe/chart',
		downloadGroupUserList: 'admin/group/user-list-download',
		getWhitelabelUserList: 'admin/whitelabel/get-user-by-whitelabel',
		assignUserToWhiteLabel: 'admin/whitelabel/add-user-to-whitelabel',
		removeUserFromWhitelabel: 'admin/whitelabel/user-from-whitelabel',
		createForecastBox: 'admin/forecast/box',
		createPdfModuleBox: 'admin/pdfModule/box',
		fetchForecastBoxData: 'admin/forecast/boxes',
		fetchPdfModuleBoxData: 'admin/pdfModule/boxes',
		fetchReportsList: 'forecast/boxes',
		fetchPdfModuleList: 'pdfModule/boxes',
		fetchReportsBoxDetails: 'forecast/box',
		fetchPdfModuleBoxDetails: 'pdfModule/box',
		adminReportsDragAndDrop: 'admin/forecast/tree',
		adminPdfModuleDragAndDrop: 'admin/pdfModule/tree',
		whiteLabelReportsSubSectorsList: 'admin/whitelabel/forecast/sub-group-list',
		whiteLabelPdfModuleSubSectorsList: 'admin/whitelabel/pdfModule/sub-group-list',
		fetchWhiteLabelReportsTreeStructure: 'admin/whitelabel/forecast/box/list',
		fetchWhiteLabelPdfModuleTreeStructure: 'admin/whitelabel/pdfModule/box/list',
		fetchWhiteLabelReportsTreeStructurePdf: 'admin/whitelabel/pdfModule/box/list',
		createWhitelabelForecastBox: 'admin/whitelabel/forecast/box',
		createWhitelabelPdfModuleBox: 'admin/whitelabel/pdfModule/box',
		deleteWhitelabelForecast: 'admin/whitelabel/forecast/delete_group',
		deleteWhitelabelPdfModule: 'admin/whitelabel/pdfModule/delete_group',
		fetchWhiteLabelForecastGroupData: 'admin/whitelabel/forecast/group_list',
		fetchWhiteLabelPdfModuleGroupData: 'admin/whitelabel/pdfModule/group_list',
		fetchWhiteLabelForecastBoxData: 'admin/whitelabel/forecast/boxes',
		fetchWhiteLabelPdfModuleBoxData: 'admin/whitelabel/pdfModule/boxes',
		updateWhiteLabelForecastGroup: 'admin/whitelabel/forecast/update_group_subgroup',
		updateWhiteLabelPdfModuleGroup: 'admin/whitelabel/pdfModule/update_group_subgroup',
		createWhiteLabelForecastGroup: 'admin/whitelabel/forecast/create-group',
		createWhiteLabelPdfModuleGroup: 'admin/whitelabel/pdfModule/create-group',
		whiteLabelForecastDragAndDrop: 'admin/whitelabel/forecast/drag-drop/sub-group',
		whiteLabelPdfModuleDragAndDrop: 'admin/whitelabel/pdfModule/drag-drop/sub-group',
		whiteLabelForecastFileVisibility: 'admin/whitelabel/file',
		whiteLabelPdfModuleFileVisibility: 'admin/whitelabel/pdf',
		fetchWhiteLabelForecastBoxes: 'whitelabel/forecast/boxes',
		fetchWhiteLabelPdfModuleBoxes: 'whitelabel/pdfModule/boxes',
		fetchWhiteLabelForecastBoxDetails: 'whitelabel/forecast/box/detail',
		fetchWhiteLabelPdfModuleBoxDetails: 'whitelabel/pdfModule/box/detail',
		fetchWhitelabelForecastDetails: 'whitelabel/list/detail',
		fetchWhitelabelPdfModuleDetails: 'whitelabel/list/detailPdf',
		updateForecastPdfVisibility: 'admin/forecast/file',
		updatePdfModulePdfVisibility: 'admin/pdfModule/file',
		whitelabelAddWidgetData: 'whitelabel/selection_data',
		downloadUserList: 'admin/users/export_user',
		downloadCountries: 'admin/tables/countries',
		downloadCurrencies: 'admin/tables/currency',
		downloadUnits: 'admin/tables/units',
		downloadTenderCountries: 'admin/tables/announcement_countries',
		downloadNotations: 'admin/tables/queatation',
		fetchMasterDataTableData: 'admin/tables/dropdown/master',
		fetchSourceDataTableData: 'admin/tables/source',
		sourceList: 'admin/tables/source',
		materialSourceList: 'materials/list/source',
		downloadAdminMasterData: 'admin/tables/master',
		downloadLogins: 'admin/users/export_logins',
		exportData: 'admin/permissions/newsMasterData',
		downloadMaterialGroup: 'admin/tables/groups',
		copyForecastKey: 'y-api',
		copyMatxSyncKey: 'admin/matx-sync/key',
		createMaterialCurrency: 'materials/currency',
		costModel: 'costmodel',
		costModelGroupVisibility: 'admin/costmodel/group_visibility',
		downloadAdminHistory: 'admin/costmodel/master_data_download',
		assignCostModelToAdmin: 'admin/permissions/costModelList',
		adminCostModelList: 'admin/permissions/costModelList',
		adminCostModelBackpackList: 'admin/backpack/costmodel',
		adminCostModelSpaces: 'admin/permissions/costModelSpaces',
		adminCostModelBackpackSpaces: 'admin/backpack/costModelSpaces',
		adminCostModelSpacesUpdate: 'admin/permissions/spacesUpdate',
		adminCostModelBackpackSpacesUpdate: 'admin/backpack/spacesUpdate',
		adminCostModelAuthorization: 'admin/permissions/costModelList',
		adminCostModelBackpackAuthorization: 'admin/backpack/contModelList',
		costModelExcelExport: 'download/costModel',
		downloadAdminMaterial: 'admin/tables/material-authorization',
		downloadUserAuthorization: 'admin/permissions/user-authorization',
		downloadBackpackAuthorization: 'admin/backpack/backpack-authorization'
	}
};

const getUrl = (url: string, params: QueryParameters | any = {}): string => {
	if (!url.includes('https')) {
		let urlString = `${API_CONFIG.baseUrl}/${url}`;
		if (params && !isEmpty(params)) {
			Object.keys(params).forEach((key) => {
				if (params[key] == null || params[key] === '') {
					delete params[key];
				}
			});
			urlString += `?${queryString.stringify(params)}`;
		}
		return urlString;
	}
	return url;
};
const getDifferenceDaysForOneYear = (endDate: any) => {
	const currentYear = endDate.getFullYear();
	const startDate = new Date(currentYear, 0, 1);
	const Difference_In_Time = endDate.getTime() - startDate.getTime();
	return Math.round(Difference_In_Time / (1000 * 3600 * 24));
};
const checkMaterialData = (data: INewsGroupData[] | IForecastGroupData[] | IMaterialGroupData[] | IPdfModuleGroupData[], operationFor: string) => {
	let isChecked = false;
	data.forEach((d: INewsGroupData | IForecastGroupData | IMaterialGroupData | IPdfModuleGroupData) => {
		if (
			(operationFor === 'forecast' && (d as IForecastGroupData).bp_id === null) ||
			(operationFor === 'pdfModule' && (d as IPdfModuleGroupData).bp_id === null) ||
			(operationFor === 'news' && (d as INewsGroupData).bn_id === null)
		) {
			isChecked = true;
		} else {
			isChecked = false;
		}
	});
	return isChecked;
};
const checkBackpackGroupData = (
	data: INewsGroupData[] | IForecastGroupData[] | IMaterialGroupData[] | IPdfModuleGroupData[],
	operationFor: string
) => {
	let isChecked = false;
	data.forEach((d: INewsGroupData | IForecastGroupData | IMaterialGroupData | IPdfModuleGroupData) => {
		if (
			(operationFor === 'forecast' && (d as IForecastGroupData).is_backpack) ||
			(operationFor === 'pdfModule' && (d as IPdfModuleGroupData).is_backpack) ||
			(operationFor === 'news' && (d as INewsGroupData).is_backpack)
		) {
			isChecked = true;
		} else {
			isChecked = false;
		}
	});
	return isChecked;
};
const pageOptions: number[] = [20, 50, 100];
const PER_PAGE = 20;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || '';
const getFileUploadFolder = (key: string) => `image/Blastv4/${ENVIRONMENT}/${key}`;
const WINDOW_WIDTH = window.innerWidth;
const URL_REGEX = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
/**
 * reactSelectStyles - css style object for react-select
 */
const reactSelectStyles = {
	option: (base: CSSProperties, state: any) => ({
		...base,
		// borderBottom: '1px solid #e7e7e7',
		color: state.isSelected ? 'white' : state.isFocused ? '' : '#272A30',
		padding: 8,
		backgroundColor: state.isSelected ? '#081d34' : state.isFocused ? '' : '',
		':active': {
			backgroundColor: '#081d34',
			color: 'white'
		},
		':hover': {
			backgroundColor: '#081d34',
			color: 'white'
		},
		':focus': {
			backgroundColor: '#081d34',
			outline: 0,
			color: 'white'
		},
		cursor: 'pointer'
	}),
	menu: (base: CSSProperties) => ({
		...base,
		zIndex: 3,
		marginTop: 4,
		border: '1px solid #D4D6D9',
		borderRadius: 8
	}),
	menuList: (base: CSSProperties) => ({
		...base,
		padding: 0,
		backgroundColor: '#ffffff !important',
		overflowX: 'hidden'
	}),
	clearIndicator: (base: CSSProperties) => ({
		...base,
		cursor: 'pointer'
	}),
	dropdownIndicator: (base: CSSProperties, state: any) => ({
		...base,
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
		color: '#081D34'
	}),
	indicatorSeparator: () => ({
		width: '0'
	}),
	control: () => ({
		// none of react-selects styles are passed to <View />
		display: 'flex',
		width: '100%',
		minHeight: '34px !important',
		border: '1px solid #EDEEEF',
		padding: '0px !important',
		borderRadius: '8px'
	}),
	singleValue: (base: CSSProperties, state: any) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = 'opacity 300ms';
		return { ...base, opacity: opacity, transition: transition };
	}
};
/**
 * reactSelectStyles - css style object for react-select
 */
const multiReactSelectStyles = {
	option: (base: CSSProperties, state: any) => ({
		...base,
		// borderBottom: '1px solid #e7e7e7',
		color: state.isSelected && '#14304F',
		padding: 8,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		backgroundColor: 'white',
		cursor: 'pointer',
		accentColor: ' #002c50 !important',
		':active': {
			backgroundColor: 'transparent',
			color: '#14304F'
		}
	}),
	menu: (base: CSSProperties) => ({
		...base,
		zIndex: 3,
		display: 'flex',
		marginTop: 4,
		border: '1px solid #D4D6D9',
		borderRadius: 4
	}),
	menuList: (base: CSSProperties) => ({
		...base,
		padding: 0,
		backgroundColor: '#ffffff !important',
		borderRadius: 4,
		width: '100%'
	}),
	clearIndicator: (base: CSSProperties) => ({
		...base,
		cursor: 'pointer'
	}),
	dropdownIndicator: (base: CSSProperties, state: any) => ({
		...base,
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
		color: '#081D34',
		padding: 0
	}),
	indicatorSeparator: () => ({
		width: '0'
	}),
	control: () => ({
		// none of react-selects styles are passed to <View />
		display: 'flex',
		width: '250px',
		minHeight: '34px !important',
		border: '1px solid #EDEEEF',
		padding: '0px !important',
		borderRadius: '8px',
		backgroundColor: '#ffffff !important'
	}),
	singleValue: (base: CSSProperties, state: any) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = 'opacity 300ms';
		return { ...base, opacity: opacity, transition: transition };
	}
};
const colorPallet = ['#4472C4', '#ED7D31', '#FFC000', '#70AD47', '#00B0F0', '#7030A0', '#FF0000', '#002060', '#000000'];
const kebabMenu: IKebabMenuList[] = [
	{ title: `${localizationConstants.addToDashboard}` },
	{ title: `${localizationConstants.rename}` },
	{ title: `${localizationConstants.extinguish}` }
];
const chartSettingColorPallet = ['#4472C4', '#ED7D31', '#FFC000', '#70AD47', '#00B0F0', '#7030A0', '#FF0000', '#002060', '#000000'];
// const responsiveTableHEading = [`${t(localizationConstants.dueDate)}`, `${localizationConstants.courses}`, `${localizationConstants.change}`];
const ImageLink = `${process.env.REACT_APP_IMAGE_LINK}`;
const passwordRegex = /^(?=.*[A-ZÄÖÜß])(?=.*[a-zäöüß])(?=.*\d)(?=.*[\W_])[A-Za-zäöüÄÖÜß\d\W_]{8,24}$/;
const DATE_FORMAT_MAPPER: { [key: string]: string } = {
	'DD.MM.YYYY': 'dd.MM.yyyy',
	'MM.DD.YYYY': 'MM.dd.yyyy',
	'YYYY.MM.DD': 'yyyy.MM.dd'
};
const courseTableHeading = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.name)}`, class: 'width--19' },
	{ header: `${t(localizationConstants.maturity)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.date)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.actual)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.hist)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.change)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.high)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.low)}`, class: 'width--10 text-align-right' },
	{ header: `${t(localizationConstants.currency)}`, class: 'width--10 text-align-right' }
];
const STROKESCOLORS: IStrokeColors = {
	ema: '#1f77b4',
	sma: '#ff7f0e',
	tma: '#d62728',
	wma: '#9467bd'
};
// const csvHeaders = [
// 	{ label: `${t(localizationConstants.name)}`, key: 'name' },
// 	{ label: `${t(localizationConstants.maturity)}`, key: 'faelligkeit_f' },
// 	{ label: `${t(localizationConstants.date)}`, key: 'datum' },
// 	{ label: `${t(localizationConstants.actual)}`, key: 'hauptkurs' },
// 	{ label: `${t(localizationConstants.hist)}`, key: 'hist_kurs' },
// 	{ label: `${t(localizationConstants.change)}`, key: 'hist_perf' },
// 	{ label: `${t(localizationConstants.high)}`, key: 'hist_hoch' },
// 	{ label: `${t(localizationConstants.low)}`, key: 'hist_tief' },
// 	{ label: `${t(localizationConstants.currency)}`, key: 'waehrung' },
// 	{ label: `${t(localizationConstants.unit)}`, key: 'einheit' },
// 	{ label: `${t(localizationConstants.histDate)}`, key: 'datum' }
// ];

const newsBackpackMasterDataHeaders = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.sector)}`, key: 'group', width: 45 },
	{ header: `${t(localizationConstants.category)}`, key: 'category', width: 45 }
];

const forecastBackpackMasterDataHeaders = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.sector)}`, key: 'group', width: 45 },
	{ header: `${t(localizationConstants.name)}`, key: 'title', width: 45 }
];

const pdfModuleBackpackMasterDataHeaders = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.sector)}`, key: 'group', width: 45 },
	{ header: `${t(localizationConstants.name)}`, key: 'title', width: 45 }
];

const userListBackpackMasterDataHeaders = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.firstname)}`, key: 'name', width: 30 },
	{ header: `${t(localizationConstants.lastName)}`, key: 'lastName', width: 30 },
	{ header: `${t(localizationConstants.email)}`, key: 'email', width: 45 }
];

const customCsvHeaders = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.name)}`, key: 'name', width: 45 },
	{ header: `${t(localizationConstants.maturity)}`, key: 'faelligkeit_f', width: 15 },
	{ header: `${t(localizationConstants.date)}`, key: 'datum', width: 15 },
	{ header: `${t(localizationConstants.actual)}`, key: 'hauptkurs', width: 15 },
	{ header: `${t(localizationConstants.hist)}`, key: 'hist_kurs', width: 15 },
	{ header: `${t(localizationConstants.change)}`, key: 'hist_perf', width: 15, horizontal: 'right' },
	{ header: `${t(localizationConstants.high)}`, key: 'hist_hoch', width: 15 },
	{ header: `${t(localizationConstants.low)}`, key: 'hist_tief', width: 15 },
	{ header: `${t(localizationConstants.currency)}`, key: 'waehrung', width: 15 },
	{ header: `${t(localizationConstants.unit)}`, key: 'einheit', width: 15 },
	{ header: `${t(localizationConstants.histDate)}`, key: 'histDatum', width: 15 }
];

const groupUserListHeader = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.groupName)}`, key: 'group', width: 45 },
	{ header: `${t(localizationConstants.userId)}`, key: 'user_id', width: 45 },
	{ header: `${t(localizationConstants.email)}`, key: 'email', width: 45 },
	{ header: `${t(localizationConstants.promotionCode)}`, key: 'code', width: 45 }
];
const adminAdvancedSearchCsvHeaders = [
	{ header: 'symbol', key: 'symbol', width: 45 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'basis_symbol', key: 'basis_symbol', width: 15 },
	{ header: 'isin', key: 'isin', width: 15 },
	{ header: 'faelligkeit', key: 'faelligkeit', width: 15 },
	{ header: 'faelligkeit_f', key: 'faelligkeit_f', width: 15, horizontal: 'right' },
	{ header: 'frei', key: 'frei', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'editierbar_', key: 'editierbar_', width: 15 },
	{ header: 'land', key: 'land', width: 15 },
	{ header: 'waehrung', key: 'waehrung', width: 15 },
	{ header: 'waehrung_ignore', key: 'waehrung_ignore', width: 15 },
	{ header: 'einheit', key: 'einheit', width: 15 },
	{ header: 'notierung', key: 'notierung', width: 15 },
	{ header: 'notierung_zusatz', key: 'notierung_zusatz', width: 15 },
	{ header: 'nkstellen', key: 'nkstellen', width: 15 },
	{ header: 'max_kursalter', key: 'max_kursalter', width: 15 },
	{ header: 'name_deu', key: 'name_deu', width: 45 },
	{ header: 'name_eng', key: 'name_eng', width: 45 },
	{ header: 'name_zusatz', key: 'name_zusatz', width: 45 },
	{ header: 'boersenname', key: 'boersenname', width: 35 },
	{ header: 'datenlieferant', key: 'datenlieferant', width: 15 },
	{ header: 'quelle', key: 'quelle', width: 15 },
	{ header: 'kunde', key: 'kunde', width: 15 },
	{ header: 'hinzugefuegt_am', key: 'hinzugefuegt_am', width: 35 },
	{ header: 'entfernt_am', key: 'entfernt_am', width: 35 },
	{ header: 'lagerbestand_symbol', key: 'lagerbestand_symbol', width: 35 },
	{ header: 'lagerbestand_boerse', key: 'lagerbestand_boerse', width: 35 },
	{ header: 'info_de', key: 'info_de', width: 35 },
	{ header: 'info_en', key: 'info_en', width: 35 },
	{ header: 'priority', key: 'priority', width: 35 },
	{ header: 'verantwortlich', key: 'verantwortlich', width: 35 },
	{ header: 'prozent_abweichung_erlaubt', key: 'prozent_abweichung_erlaubt', width: 35 },
	{ header: 'aid_kommentar_', key: 'aid_kommentar_', width: 15 },
	{ header: 'link', key: 'link', width: 90 },
	{ header: 'notierung_zusatz_en', key: 'notierung_zusatz_en', width: 35 },
	{ header: 'aid_kommentar_', key: 'aid_kommentar_', width: 35 }
];
const apiMasterDataCsvHeaders = [
	{ header: 'symbol', key: 'symbol', width: 15 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'basis_symbol', key: 'basis_symbol', width: 15 },
	{ header: 'isin', key: 'isin', width: 15 },
	{ header: 'faelligkeit', key: 'faelligkeit', width: 15 },
	{ header: 'faelligkeit_f', key: 'faelligkeit_f', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'land', key: 'land', width: 15 },
	{ header: 'waehrung', key: 'waehrung', width: 15 },
	{ header: 'einheit', key: 'einheit', width: 15 },
	{ header: 'notierung', key: 'notierung', width: 15 },
	{ header: 'notierung_zusatz', key: 'notierung_zusatz', width: 15 },
	{ header: 'name_deu', key: 'name_deu', width: 60 },
	{ header: 'name_eng', key: 'name_eng', width: 60 },
	{ header: 'name_zusatz', key: 'name_zusatz', width: 60 },
	{ header: 'quelle', key: 'quelle', width: 45 }
];

const apiMasterDataNewsCsvHeaders = [
	{ header: 'kategorie_id', key: 'kategorie_id', width: 15 },
	{ header: 'kategorie', key: 'kategorie', width: 60 },
	{ header: 'kategorie_eng', key: 'kategorie_eng', width: 60 },
	{ header: 'quelle', key: 'quelle', width: 30 },
	{ header: 'grusel', key: 'grusel', width: 30 }
];

const adminListEntriesHeader = [
	{ header: 'symbol', key: 'symbol', width: 15 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'basis_symbol', key: 'basis_symbol', width: 15 },
	{ header: 'isin', key: 'isin', width: 15 },
	{ header: 'faelligkeit', key: 'faelligkeit', width: 15 },
	{ header: 'faelligkeit_f', key: 'faelligkeit_f', width: 15 },
	{ header: 'frei', key: 'frei', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'land', key: 'land', width: 15 },
	{ header: 'waehrung', key: 'waehrung', width: 15 },
	{ header: 'einheit', key: 'einheit', width: 15 },
	{ header: 'name_deu', key: 'name_deu', width: 60 },
	{ header: 'name_eng', key: 'name_eng', width: 60 },
	{ header: 'kurszeit', key: 'kurszeit', width: 40 },
	{ header: 'letzter', key: 'letzter', width: 15 },
	{ header: 'settlement', key: 'settlement', width: 15 },
	{ header: 'geld', key: 'geld', width: 15 },
	{ header: 'brief', key: 'brief', width: 15 },
	{ header: 'hauptkursfeld_soll', key: 'hauptkursfeld_soll', width: 40 }
];
const adminMasterDataHeaders = [
	{ header: 'symbol', key: 'symbol', width: 15 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'basis_symbol', key: 'basis_symbol', width: 15 },
	{ header: 'isin', key: 'isin', width: 15 },
	{ header: 'faelligkeit', key: 'faelligkeit', width: 15 },
	{ header: 'faelligkeit_f', key: 'faelligkeit_f', width: 15 },
	{ header: 'frei', key: 'frei', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'editierbar_', key: 'editierbar_', width: 15 },
	{ header: 'land', key: 'land', width: 15 },
	{ header: 'waehrung', key: 'waehrung', width: 15 },
	{ header: 'waehrung_ignore', key: 'waehrung_ignore', width: 15 },
	{ header: 'einheit', key: 'einheit', width: 15 },
	{ header: 'notierung', key: 'notierung', width: 15 },
	{ header: 'notierung_zusatz', key: 'notierung_zusatz', width: 15 },
	{ header: 'nkstellen', key: 'nkstellen', width: 15 },
	{ header: 'max_kursalter', key: 'max_kursalter', width: 15 },
	{ header: 'name_deu', key: 'name_deu', width: 60 },
	{ header: 'name_eng', key: 'name_eng', width: 60 },
	{ header: 'name_zusatz', key: 'name_zusatz', width: 15 },
	{ header: 'boersenname', key: 'boersenname', width: 15 },
	{ header: 'datenlieferant', key: 'datenlieferant', width: 15 },
	{ header: 'quelle', key: 'quelle', width: 15 },
	{ header: 'kunde', key: 'kunde', width: 15 },
	{ header: 'hinzugefuegt_am', key: 'hinzugefuegt_am', width: 30 },
	{ header: 'entfernt_am', key: 'entfernt_am', width: 30 },
	{ header: 'lagerbestand_symbol', key: 'lagerbestand_symbol', width: 30 },
	{ header: 'lagerbestand_boerse', key: 'lagerbestand_boerse', width: 30 },
	{ header: 'info_de', key: 'info_de', width: 30 },
	{ header: 'info_en', key: 'info_en', width: 30 },
	{ header: 'priority', key: 'priority', width: 30 },
	{ header: 'verantwortlich', key: 'verantwortlich', width: 30 },
	{ header: 'prozent_abweichung_erlaubt', key: 'prozent_abweichung_erlaubt', width: 30 },
	{ header: 'aid_kommentar_', key: 'aid_kommentar_', width: 100 },
	{ header: 'link', key: 'link', width: 90 },
	{ header: 'notierung_zusatz_en', key: 'notierung_zusatz_en', width: 35 },
	{ header: 'aid_kommentar_', key: 'aid_kommentar_', width: 35 }
];
const matfoxxOffersListHeaders = [
	{ header: 'offer', key: 'offer', width: 45 },
	{ header: 'offer_eng', key: 'offer_eng', width: 45 },
	{ header: 'link', key: 'link', width: 30 },
	{ header: 'start_date', key: 'start_date', width: 15, style: { numFmt: 'yyyy-mm-dd' } },
	{ header: 'end_date', key: 'end_date', width: 15, style: { numFmt: 'yyyy-mm-dd' } }
];

const newsListHeaders = [
	{ header: 'kategorie_id', key: 'kategorie_id', width: 15 },
	{ header: 'kategorie', key: 'kategorie', width: 60 },
	{ header: 'kategorie_eng', key: 'kategorie_eng', width: 60 },
	{ header: 'quelle', key: 'quelle', width: 15 },
	{ header: 'grusel', key: 'grusel', width: 15 }
];
const matfoxxJokesListHeaders = [
	{ header: 'joke', key: 'joke', width: 60 },
	{ header: 'joke_eng', key: 'joke_eng', width: 60 },
	{ header: 'date', key: 'date', width: 30, style: { numFmt: 'yyyy-mm-dd' } }
];
const DateRangeMapper: { [key: string | number]: any } = {
	'1w': [7, 'days'],
	'1m': [1, 'month'],
	'3m': [3, 'month'],
	'6m': [6, 'month'],
	'1y': [1, 'year'],
	'3y': [3, 'year'],
	'5y': [5, 'year'],
	'10y': [10, 'year'],
	'20y': [20, 'year']
};
export const spanMapper: ISpanMapper = {
	'1m': 30,
	'3m': 90,
	'6m': 180,
	'1y': 365,
	ytd: getDifferenceDaysForOneYear(new Date()),
	max: 'max'
};
const createOption = (label: string) => {
	return { label: label, value: label };
};
const materialUserCourseTableHeading = (t: TFunction<'translation', undefined, 'translation'>, options: { showSources?: boolean } = {}) => {
	const headings = [
		{ header: `${t(localizationConstants.name)}`, class: 'width--19' },
		{ header: `${t(localizationConstants.maturity)}`, class: 'width--10 text-align-right' },
		{ header: `${t(localizationConstants.country)}`, class: 'width--10 text-align-right' }
	];

	if (options.showSources) {
		headings.push({ header: `${t(localizationConstants.source)}`, class: 'width--10 text-align-right' });
	}

	headings.push(
		{ header: `${t(localizationConstants.kurszeit)}`, class: 'width--10 text-align-right' },
		{ header: `${t(localizationConstants.currency)}`, class: 'width--10 text-align-right' }
	);
	return headings;
};

const DATE_PLACEHOLDER_MAPPER: any = (langugae: string) => {
	return {
		'DD.MM.YYYY': langugae === 'de' ? 'TT.MM.JJJJ' : 'DD.MM.YYYY',
		'MM.DD.YYYY': langugae === 'de' ? 'MM.TT.JJJJ' : 'MM.DD.YYYY',
		'YYYY.MM.DD': langugae === 'de' ? 'JJJJ.MM.TT' : 'YYYY.MM.DD'
	};
};
const protocolListHeaders = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.userId)}`, class: '' },
	{ header: `${t(localizationConstants.uploadedBy)}`, class: '' },
	{ header: `${t(localizationConstants.fileName)}`, class: '' },
	{ header: `${t(localizationConstants.inserted)}`, class: 'text-align-right' },
	{ header: `${t(localizationConstants.updated)}`, class: 'text-align-right' },
	{ header: `${t(localizationConstants.processes)}`, class: 'text-align-right' },
	{ header: `${t(localizationConstants.errors)}`, class: 'text-align-center' }
];
const courseDateRange: any = (language: string) => {
	return [
		{
			id: ' 0',
			title: `${(language === 'en' && '1D') || '1T'}`,
			value: '1d'
		},
		{
			id: ' 1',
			title: `${(language === 'en' && '1W') || '1W'}`,
			value: '1w'
		},
		{
			id: ' 2',
			title: `${(language === 'en' && '1M') || '1M'}`,
			value: '1m'
		},
		{
			id: ' 3',
			title: `${(language === 'en' && '3M') || '3M'}`,
			value: '3m'
		},
		{
			id: ' 4',
			title: `${(language === 'en' && '6M') || '6M'}`,
			value: '6m'
		},
		{
			id: ' 5',
			title: `${(language === 'en' && '1Y') || '1J'}`,
			value: '1y'
		},
		{
			id: ' 6',
			title: `${(language === 'en' && '3Y') || '3J'}`,
			value: '3y'
		},
		{
			id: ' 7',
			title: `${(language === 'en' && '5Y') || '5J'}`,
			value: '5y'
		},
		{
			id: ' 8',
			title: `${(language === 'en' && '10Y') || '10J'}`,
			value: '10y'
		}
	];
};

const statisticsDateRange: any = (language: string) => {
	return [
		{
			id: ' 1',
			title: `${(language === 'en' && '1W') || '1W'}`,
			value: '1w'
		},
		{
			id: ' 2',
			title: `${(language === 'en' && '1M') || '1M'}`,
			value: '1m'
		},
		{
			id: ' 3',
			title: `${(language === 'en' && '3M') || '3M'}`,
			value: '3m'
		},
		{
			id: ' 4',
			title: `${(language === 'en' && '6M') || '6M'}`,
			value: '6m'
		},
		{
			id: ' 5',
			title: `${(language === 'en' && '1Y') || '1J'}`,
			value: '1y'
		},
		{
			id: ' 6',
			title: `${(language === 'en' && 'All') || 'All'}`,
			value: 'all'
		}
	];
};

const adminAuthUserNavbar = [
	{
		name: `${localizationConstants.materials}`,
		id: 0
	},
	// {
	// 	name: `${localizationConstants.API}`,
	// 	id: 1
	// },
	{
		name: `${localizationConstants.news}`,
		id: 2
	},
	{
		name: `${localizationConstants.forecasts}`,
		id: 3
	},
	{
		name: `${localizationConstants.pdfModule}`,
		id: 4
	},
	{
		name: `${localizationConstants.backpack}`,
		id: 6
	},
	{
		name: `${localizationConstants.tenders}`,
		id: 7
	},
	{
		name: `${localizationConstants.costModel}`,
		id: 8
	},
	{
		name: `Dashboards`,
		id: 5
	},
	{
		name: `${localizationConstants.myMaterials}`,
		id: 10
	},
	{
		name: `${localizationConstants.statistics}`,
		id: 11
	}
	// {
	// 	name: `${localizationConstants.statistics}`,
	// 	id: 4
	// },
];
const adminAuthBackpackNavbar = [
	{
		name: `${localizationConstants.materials}`,
		id: 0
	},
	// {
	// 	name: `${localizationConstants.API}`,
	// 	id: 1
	// },
	{
		name: `${localizationConstants.news}`,
		id: 2
	},
	{
		name: `${localizationConstants.forecasts}`,
		id: 3
	},
	{
		name: `${localizationConstants.pdfModule}`,
		id: 4
	},
	{
		name: `${localizationConstants.tenders}`,
		id: 5
	},
	{
		name: `${localizationConstants.costModel}`,
		id: 8
	}
];
const COLOR_FIELDS: IColor[] = [
	{ key: 'primary_color', label: 'Primary color' },
	{ key: 'primary_light_color', label: 'Primary light color' },
	{ key: 'primary_lighter_color', label: 'Primary lighter color' },
	{ key: 'accent_yellow_color', label: 'Accent yellow color' },
	{ key: 'success_color', label: 'Success color' },
	{ key: 'error_color', label: 'Error color' },
	{ key: 'red_light_color', label: 'Red light color' },
	{ key: 'blue_color', label: 'Blue color' },
	{ key: 'greyscale_0', label: 'Greyscale 0' },
	{ key: 'greyscale_5', label: 'Greyscale 5' },
	{ key: 'greyscale_10', label: 'Greyscale 10' },
	{ key: 'greyscale_20', label: 'Greyscale 20' },
	{ key: 'greyscale_25', label: 'Greyscale 25' },
	{ key: 'greyscale_30', label: 'Greyscale 30' },
	{ key: 'greyscale_40', label: 'Greyscale 40' },
	{ key: 'greyscale_50', label: 'Greyscale 50' },
	{ key: 'greyscale_60', label: 'Greyscale 60' },
	{ key: 'greyscale_70', label: 'Greyscale 70' },
	{ key: 'greyscale_80', label: 'Greyscale 80' },
	{ key: 'greyscale_90', label: 'Greyscale 90' },
	{ key: 'greyscale_100', label: 'Greyscale 100' }
];

const costModelTableHeader = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ header: `${t(localizationConstants.componentName)}`, class: 'text-align-left' },
	{ header: `${t(localizationConstants.date)}`, class: 'text-align-center' },
	{ header: `${t(localizationConstants.price)}`, class: 'text-align-center' },
	{ header: `${t(localizationConstants.change)}`, class: 'text-align-center' }
];

const englishLocale = {
	dateTime: '%x, %X',
	date: '%-m/%-d/%Y',
	time: '%-I:%M:%S %p',
	periods: ['AM', 'PM'],
	days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};

const germanLocale = {
	dateTime: '%A, der %e. %B %Y, %X',
	date: '%d.%m.%Y',
	time: '%H:%M:%S',
	periods: ['AM', 'PM'],
	days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
	shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
	shortMonths: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
};

const whiteSpceRegex = / +/g;

const mouseEdgeAppearance = {
	textFill: '#542605',
	stroke: '#05233B',
	strokeOpacity: 1,
	fill: '#FFF'
};

const IMAGE_EXPORT_BUTTON_ARRAY = ['PNG', 'JPEG', 'SVG', 'PDF'];

const adminMatrialForecastExcelHeaders = [
	{ header: 'symbol', key: 'symbol', width: 15 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'datum', key: 'datum', width: 15 },
	{ header: 'letzter', key: 'letzter', width: 15 },
	{ header: 'umsatz', key: 'umsatz', width: 15 },
	{ header: 'settlement', key: 'settlement', width: 15 },
	{ header: 'oi', key: 'oi', width: 15 },
	{ header: 'geld', key: 'geld', width: 15 },
	{ header: 'brief', key: 'brief', width: 15 },
	{ header: 'erster', key: 'erster', width: 15 },
	{ header: 'hoch', key: 'hoch', width: 15 },
	{ header: 'tief', key: 'tief', width: 15 }
];

const adminMatrialIntradayHeaders = [
	{ header: 'symbol', key: 'symbol', width: 15 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'datum', key: 'datum', width: 15 },
	{ header: 'zeit', key: 'zeit', width: 15 },
	{ header: 'kurs', key: 'kurs', width: 15 },
	{ header: 'umsatz', key: 'umsatz', width: 15 },
	{ header: 'kurstyp', key: 'kurstyp', width: 15 }
];

const downloadMaterialGroupHeaders: any = {
	Gruppen: [
		{ header: 'gruppen_id', key: 'gruppen_id', width: 15 },
		{ header: 'eltern_id', key: 'eltern_id', width: 15 },
		{ header: 'gruppe', key: 'gruppe', width: 15 },
		{ header: 'gruppe_eng', key: 'gruppe_eng', width: 30 },
		{ header: 'sortidx', key: 'sortidx', width: 15 },
		{ header: 'sichtbar', key: 'sichtbar', width: 15 },
		{ header: 'delete', key: 'delete', width: 15 }
	],
	Listen: [
		{ header: 'listen_id', key: 'listen_id', width: 15 },
		{ header: 'benutzer_id', key: 'benutzer_id', width: 15 },
		{ header: 'gruppen_id', key: 'gruppen_id', width: 15 },
		{ header: 'gruppe', key: 'gruppe', width: 15 },
		{ header: 'listen_name', key: 'listen_name', width: 30 },
		{ header: 'anmerkung', key: 'anmerkung', width: 30 },
		{ header: 'umrechnen_erlaubt', key: 'umrechnen_erlaubt', width: 15 },
		{ header: 'sichtbar', key: 'sichtbar', width: 15 },
		{ header: 'listen_name_eng', key: 'listen_name_eng', width: 15 },
		{ header: 'delete', key: 'delete', width: 15 }
	],
	Materialien: [
		{ header: 'listen_id', key: 'listen_id', width: 15 },
		{ header: 'symbol', key: 'symbol', width: 15 },
		{ header: 'boerse', key: 'boerse', width: 15 },
		{ header: 'alt_name', key: 'alt_name', width: 15 },
		{ header: 'sort_nr', key: 'sort_nr', width: 15 },
		{ header: 'delete', key: 'delete', width: 15 }
	]
};

const checkExpiredDate = (expiredDate: any) => {
	const today = new Date();
	const expirationDate = new Date(expiredDate);
	return expirationDate < today;
};

const CHARTMAPPER: ISpanMapper = {
	area: 'area',
	candle: 'candle',
	line: 'line',
	candlestick: 'candle'
};

const durationOptions = (t: TFunction<'translation', undefined, 'translation'>) => {
	const options = [
		{ label: `${t(localizationConstants.doNotMetter)}`, value: '' },
		{ label: `${t(localizationConstants.withoutDueDate)}`, value: 'withoutduedate' },
		{ label: `${t(localizationConstants.withoutFutures)}`, value: 'withoutfutures' },
		{ label: `${t(localizationConstants.futurePerptualContracsOnly)}`, value: 'futureperpetualcontracts' },
		{ label: `${t(localizationConstants.futureWithoutEndlessContract)}`, value: 'futureswithoutendlesscontracts' }
	];
	return options;
};

const defArray = ['atr', 'rsi', 'macd', 'sto'];

const radioButtonArray = (t: TFunction<'translation', undefined, 'translation'>) => {
	return [
		{
			name: t(localizationConstants.customMaterialStructure),
			radioBtns: [
				{
					name: 'material_status',
					label: t(localizationConstants.active),
					value: 'active'
				},
				{
					name: 'material_status',
					label: t(localizationConstants.activePlusOriginal),
					value: 'active+original'
				},
				{
					name: 'material_status',
					label: t(localizationConstants.inactive),
					value: 'inactive'
				},
				{
					name: 'material_status',
					label: t(localizationConstants.hideAll),
					value: 'hideall'
				}
			]
		},
		{
			name: t(localizationConstants.customNewsStructures),
			radioBtns: [
				{
					name: 'news_status',
					label: t(localizationConstants.active),
					value: 'active'
				},
				{
					name: 'news_status',
					label: t(localizationConstants.activePlusOriginal),
					value: 'active+original'
				},
				{
					name: 'news_status',
					label: t(localizationConstants.inactive),
					value: 'inactive'
				},
				{
					name: 'news_status',
					label: t(localizationConstants.hideAll),
					value: 'hideall'
				}
			]
		},
		{
			name: t(localizationConstants.customForecastStructure),
			radioBtns: [
				{
					name: 'forecast_status',
					label: t(localizationConstants.active),
					value: 'active'
				},
				{
					name: 'forecast_status',
					label: t(localizationConstants.activePlusOriginal),
					value: 'active+original'
				},
				{
					name: 'forecast_status',
					label: t(localizationConstants.inactive),
					value: 'inactive'
				},
				{
					name: 'forecast_status',
					label: t(localizationConstants.hideAll),
					value: 'hideall'
				}
			]
		},
		{
			name: t(localizationConstants.customPdfModuleStructure),
			radioBtns: [
				{
					name: 'pdfModule_status',
					label: t(localizationConstants.active),
					value: 'active'
				},
				{
					name: 'pdfModule_status',
					label: t(localizationConstants.activePlusOriginal),
					value: 'active+original'
				},
				{
					name: 'pdfModule_status',
					label: t(localizationConstants.inactive),
					value: 'inactive'
				},
				{
					name: 'pdfModule_status',
					label: t(localizationConstants.hideAll),
					value: 'hideall'
				}
			]
		}
	] as IRadioButtonArray[];
};

const downloadCurrenciesHeader = [
	{ header: 'waehrung', key: 'waehrung', width: 15 },
	{ header: 'wfaktor', key: 'wfaktor', width: 15 },
	{ header: 'name_de', key: 'name_de', width: 30 },
	{ header: 'name_en', key: 'name_en', width: 30 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'sortidx', key: 'sortidx', width: 15 }
];

const downloadHeader = [
	{ header: 'kategorie_id', key: 'kategorie_id', width: 15 },
	{ header: 'kategorie', key: 'kategorie', width: 30 },
	{ header: 'kategorie_eng', key: 'kategorie_eng', width: 40 },
	{ header: 'grusel', key: 'grusel', width: 30 }
];

const downloadUnitsHeaders = [
	{ header: 'einheit', key: 'einheit', width: 30 },
	{ header: 'name', key: 'name', width: 30 },
	{ header: 'name_en', key: 'name_en', width: 15 },
	{ header: 'efaktor', key: 'efaktor', width: 30 },
	{ header: 'egruppe', key: 'egruppe', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'egruppe_bez', key: 'egruppe_bez', width: 15 }
];

const downloadCountriesAndRegions = [
	{ header: 'land', key: 'land', width: 15 },
	{ header: 'name_de', key: 'name_de', width: 15 },
	{ header: 'region', key: 'region', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'sortidx', key: 'sortidx', width: 15 }
];

const downloadNotations = [
	{ header: 'notierung', key: 'notierung', width: 15 },
	{ header: 'name', key: 'name', width: 15 },
	{ header: 'name_en', key: 'name_en', width: 15 },
	{ header: 'sortidx', key: 'sortidx', width: 15 }
];

const downloadTenadersCountriesHeaders: any = {
	Country_Structure: [
		{ header: 'Country ID', key: 'Country ID', width: 15 },
		{ header: 'Continent EN', key: 'Continent EN', width: 25 },
		{ header: 'Country EN', key: 'Country EN', width: 25 },
		{ header: 'Continent DE', key: 'Continent DE', width: 25 },
		{ header: 'Country DE', key: 'Country DE', width: 25 }
	],
	Country_mapping: [
		{ header: 'Country_ID', key: 'Country_ID', width: 15 },
		{ header: 'County', key: 'County', width: 25 }
	],
	Sector_Structure: [
		{ header: 'Sector ID', key: 'Sector ID', width: 15 },
		{ header: 'Sector EN', key: 'Sector EN', width: 25 },
		{ header: 'Sector DE', key: 'Sector DE', width: 25 }
	],
	Sector_Mapping: [
		{ header: 'Sector_ID', key: 'Sector_ID', width: 15 },
		{ header: 'Sector', key: 'Sector', width: 100 }
	],
	Financer_Structure: [
		{ header: 'Financer ID', key: 'Financer ID', width: 15 },
		{ header: 'Financer EN', key: 'Financer EN', width: 25 },
		{ header: 'Financer DE', key: 'Financer DE', width: 25 }
	],
	Financer_Mapping: [
		{ header: 'Financer_ID', key: 'Financer_ID', width: 15 },
		{ header: 'Financer', key: 'Financer', width: 100 }
	]
};

const downloadAdminMasterDataHeaders = [
	{ header: 'symbol', key: 'symbol', width: 15 },
	{ header: 'boerse', key: 'boerse', width: 15 },
	{ header: 'basis_symbol', key: 'basis_symbol', width: 15 },
	{ header: 'isin', key: 'isin', width: 15 },
	{ header: 'faelligkeit', key: 'faelligkeit', width: 15 },
	{ header: 'faelligkeit_f', key: 'faelligkeit_f', width: 15 },
	{ header: 'frei', key: 'frei', width: 15 },
	{ header: 'sichtbar', key: 'sichtbar', width: 15 },
	{ header: 'editierbar_', key: 'editierbar_', width: 15 },
	{ header: 'land', key: 'land', width: 15 },
	{ header: 'waehrung', key: 'waehrung', width: 15 },
	{ header: 'waehrung_ignore', key: 'waehrung_ignore', width: 15 },
	{ header: 'einheit', key: 'einheit', width: 15 },
	{ header: 'notierung', key: 'notierung', width: 15 },
	{ header: 'notierung_zusatz', key: 'notierung_zusatz', width: 180 },
	{ header: 'nkstellen', key: 'nkstellen', width: 15 },
	{ header: 'max_kursalter', key: 'max_kursalter', width: 15 },
	{ header: 'name_deu', key: 'name_deu', width: 90 },
	{ header: 'name_eng', key: 'name_eng', width: 90 },
	{ header: 'name_zusatz', key: 'name_zusatz', width: 90 },
	{ header: 'boersenname', key: 'boersenname', width: 90 },
	{ header: 'datenlieferant', key: 'datenlieferant', width: 15 },
	{ header: 'quelle', key: 'quelle', width: 45 },
	{ header: 'kunde', key: 'kunde', width: 15 },
	{ header: 'aid_kommentar_', key: 'aid_kommentar_', width: 60 },
	{ header: 'prozent_abweichung_erlaubt', key: 'prozent_abweichung_erlaubt', width: 45 },
	{ header: 'verantwortlich', key: 'verantwortlich', width: 15 },
	{ header: 'info_de', key: 'info_de', width: 15 },
	{ header: 'info_en', key: 'info_en', width: 15 },
	{ header: 'priority', key: 'priority', width: 15 },
	{ header: 'link', key: 'link', width: 90 },
	{ header: 'hinzugefuegt_am', key: 'hinzugefuegt_am', width: 30 },
	{ header: 'entfernt_am', key: 'entfernt_am', width: 30 },
	{ header: 'lagerbestand_symbol', key: 'lagerbestand_symbol', width: 30 },
	{ header: 'lagerbestand_boerse', key: 'lagerbestand_boerse', width: 30 },
	{ header: 'notierung_zusatz_en', key: 'notierung_zusatz_en', width: 30 }
];

const downloadUserLogins = [
	{ header: 'Benutzer Id', key: 'benutzer_id', width: 15 },
	{ header: 'Email', key: 'email', width: 30 },
	{ header: 'Anrede', key: 'anrede', width: 15 },
	{ header: 'Vorname', key: 'vorname', width: 20 },
	{ header: 'Nachname', key: 'nachname', width: 15 },
	{ header: 'Last Login Date', key: 'lastLoginDate', width: 30 },
	{ header: 'Last Login Time', key: 'lastLoginTime', width: 30 },
	{ header: 'Last Seen (In Days)', key: 'lastSeen', width: 20 }
];

const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg'];
const FILE_SIZE = 1 * 1024 * 1024; // 1 MB

const timeMapper: { [key: string]: string } = {
	'1d': 'Daily',
	'1w': 'Weekly',
	'1m': 'Monthly',
	'3m': '3 Months',
	'6m': '6 Months',
	'1y': '1 Year',
	all: 'All'
};

const alertCountKeys: { [key: string]: string } = {
	material: 'materialsalert',
	news: 'newsalert',
	tenders: 'tenderAlert',
	projects: 'projectAlert'
};

const memoizedStyles: StylesConfig<IDropDownOption, false> = {
	option: (base, state) => ({
		...base,
		color: state.isSelected ? '#14304F' : undefined,
		backgroundColor: '#FFC4C4 !important',
		cursor: 'pointer',
		padding: '2px 5px 2px 5px'
	}),
	menu: (base) => ({
		...base,
		zIndex: 9999999999,
		position: 'absolute',
		display: 'flex',
		marginTop: 4,
		borderRadius: '5px',
		width: 'max-content',
		boxSizing: 'border-box'
	}),
	menuList: (base) => ({
		...base,
		padding: 0,
		borderRadius: 4
	}),
	control: () => ({
		display: 'flex',
		height: '23px !important',
		border: '1px solid #081D34',
		padding: '0px !important',
		borderRadius: '5px',
		backgroundColor: '#FFF',
		width: '46px',
		cursor: 'pointer',
		fontWeight: '600',
		fontSize: '12px'
	}),
	groupHeading: (base) => ({
		...base,
		fontSize: 20,
		fontWeight: 700,
		color: 'black',
		textTransform: 'capitalize'
	}),
	valueContainer: () => ({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '1px 4px 2px 4px',
		boxSizing: 'border-box',
		width: '100%'
	}),
	container: (base) => ({
		...base,
		marginRight: '5px'
	}),
	multiValue: (base) => ({
		...base,
		marginRight: '0px !important'
	})
};

const browserLanguage = navigator.language.slice(0, 2); // 'en', 'de', etc.

const alertIcon: { [key: string]: React.FC<Props> } = {
	material: MaterialMenuIcon,
	news: NewsMenuIcon,
	tenders: TenderMenuIcon,
	projects: TenderAlerTabIcon
};
const chartSettingColor = ['#ED7D31', '#FFC000', '#70AD47', '#00B0F0', '#7030A0', '#FF0000', '#002060', '#000000'];
const compareChartSettingColor = ['#FFC000', '#70AD47', '#00B0F0', '#7030A0', '#FF0000', '#002060', '#000000'];
const UploadFileName = ['Kurse', 'Stammdaten', 'Kurshistorie'];
const AuthorizationFileName = 'Matflixx_Berechtigungen';

const chartColors = ['#FF9100', '#8CEA80', '#A81FF8'];

const getErrorMessage = (code: string, t: TFunction<'translation', undefined, 'translation'>) => {
	const ERROR_CODE: { [key: string]: string } = {
		ERR_1: t(localizationConstants.errorOne),
		ERR_2: t(localizationConstants.errorTwo),
		ERR_3: t(localizationConstants.errorThree),
		ERR_4: t(localizationConstants.errorFour),
		ERR_5: t(localizationConstants.errorFive),
		ERR_6: t(localizationConstants.errorSix),
		ERR_7: t(localizationConstants.errorSeven),
		ERR_8: t(localizationConstants.errorEight),
		ERR_9: t(localizationConstants.errorNine)
	};

	return ERROR_CODE[code] || t(localizationConstants.unKnownError);
};

const advantage = [
	`${localizationConstants.customizable}`,
	`${localizationConstants.automaticNotifications}`,
	`${localizationConstants.efficientMarketMonitoring}`
];

const tenderDescription = [
	{
		count: 1,
		item: localizationConstants.newsStepOne,
		description: ''
	},
	{
		count: 2,
		item: localizationConstants.newsStepTwo,
		description: localizationConstants.tenderStepTwoDescription
	},
	{
		count: 3,
		item: localizationConstants.tenderStepThree,
		description: localizationConstants.tenderStepThreeDescription
	}
];

const tenderData = [
	{
		count: 1,
		item: localizationConstants.tenderStepOneReading,
		description: localizationConstants.tenderStepOneReadingDescription
	},
	{
		count: 2,
		item: localizationConstants.newsStepThree,
		description: localizationConstants.tenderStepTwoReadingDescription
	},
	{
		count: 3,
		item: localizationConstants.newsStepTwo,
		description: localizationConstants.tenderStepThreeReadingDescription
	},
	{
		count: 4,
		item: localizationConstants.tenderStepThree,
		description: localizationConstants.tenderStepThreeDescription
	}
];

const materialDescription = [
	{
		count: 1,
		item: localizationConstants.courseStepOne,
		description: localizationConstants.courseStepOneDescription
	},
	{
		count: 2,
		item: localizationConstants.courseStepTwo,
		description: localizationConstants.courseStepTwoDescription
	},
	{
		count: 3,
		item: localizationConstants.courseStepThree,
		description: localizationConstants.courseStepThreeDescription
	},
	{
		count: 4,
		item: localizationConstants.courseStepFour,
		description: localizationConstants.courseStepFourDescription
	},
	{
		count: 5,
		item: localizationConstants.courseStepFive,
		description: localizationConstants.courseStepFiveDescription
	}
];

const newsData = [
	{
		count: 1,
		item: localizationConstants.newsStepOne,
		description: ''
	},
	{
		count: 2,
		item: localizationConstants.newsStepTwo,
		description: localizationConstants.newsStepTwoDescription
	}
];

const newsDataDescription = [
	{
		count: 1,
		item: localizationConstants.newsStepThree,
		description: localizationConstants.newsStepThreeDescription
	},
	{
		count: 2,
		item: localizationConstants.newsStepTwo,
		description: localizationConstants.newsStepFourDescription
	}
];

export type TimeSpan = '1d' | '1w' | '1m' | '3m' | '1y';

const columnHeading = [
	{ name: localizationConstants.componentName, className: 'text-align-left width-190px' },
	{ name: localizationConstants.date, className: 'text-align-center' },
	{ name: localizationConstants.current, className: 'text-align-center' },
	{ name: localizationConstants.historic, className: 'text-align-center' },
	{ name: localizationConstants.change, className: 'text-align-center' }
];

const centerTextDesign = [
	{ fontWeight: '500', size: 24, fontColor: '#081D34', lineHeight: 30 },
	{ fontWeight: '500', size: 16, fontColor: '#FF9100', lineHeight: 22 },
	{ fontWeight: '400', size: 14, fontColor: '#081D34', lineHeight: 20 }
];

const chartType = (t: TFunction<'translation', undefined, 'translation'>) => {
	return [
		{
			label: `${t(localizationConstants.area)}`,
			value: 'area'
		},
		{
			label: `${t(localizationConstants.bar)}`,
			value: 'bar'
		},
		{
			label: `${t(localizationConstants.line)}`,
			value: 'line'
		}
	];
};

const chartMapper = (t: TFunction<'translation', undefined, 'translation'>): { [key: string]: string } => {
	return {
		defaultArea: `${t(localizationConstants.type)}`,
		area: `${t(localizationConstants.area)}`,
		bar: `${t(localizationConstants.bar)}`,
		line: `${t(localizationConstants.line)}`
	};
};

const spanDropDownOptions = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ label: `1 ${t(localizationConstants.week)}`, value: '1w' },
	{ label: `1 ${t(localizationConstants.month)}`, value: '1m' },
	{ label: `3 ${t(localizationConstants.months)}`, value: '3m' },
	{ label: `1 ${t(localizationConstants.year)}`, value: '1y' }
];

const barSpanDropDown = (t: TFunction<'translation', undefined, 'translation'>) => [
	{ label: `${t(localizationConstants.daily)}`, value: '1d' },
	{ label: `${t(localizationConstants.weekly)}`, value: '1w' },
	{ label: `${t(localizationConstants.monthly)}`, value: '1m' },
	{ label: `${t(localizationConstants.yearly)}`, value: '1y' }
];

const chartUpdateFrequencyMapper = (t: TFunction<'translation', undefined, 'translation'>, frequency: string) => {
	const mapper: { [key: string]: string } = {
		'2': `${t(localizationConstants.biMonthly)}`,
		B: `${t(localizationConstants.biWeekly)}`,
		C: `${t(localizationConstants.continually)}`,
		H: `${t(localizationConstants.halfYearly)}`,
		I: `${t(localizationConstants.irregular)}`,
		D: `${t(localizationConstants.chartUpdateDaily)}`,
		M: `${t(localizationConstants.chartUpdateMonthly)}`,
		W: `${t(localizationConstants.chartUpdateWeekly)}`,
		Q: `${t(localizationConstants.chartUpdateQuarterly)}`,
		Y: `${t(localizationConstants.chartUpdateYearly)}`
	};
	return mapper[frequency];
};

const decimalSeparatorOptions: RadioOption[] = [
	{ value: 'de', label: '1.000,00' },
	{ value: 'en', label: '1,000.00' }
];

const ChartTypeOption = (t: TFunction<'translation', undefined, 'translation'>): RadioOption[] => {
	return [
		{ value: 'area', label: `${t(localizationConstants.surface)}` },
		{ value: 'line', label: `${t(localizationConstants.lines)}` },
		{ value: 'bar', label: `${t(localizationConstants.barChart)}` }
	];
};

const languageOptions = (t: TFunction<'translation', undefined, 'translation'>): RadioOption[] => {
	return [
		{ value: 'de', label: `${t(localizationConstants.german)}`, icon: DEFlagIcon },
		{ value: 'en', label: `${t(localizationConstants.english)}`, icon: UKFlagIcon }
	];
};

const FrequencyMapper: Record<string, string> = {
	D: 'daily',
	W: 'weekly',
	M: 'monthly',
	Q: 'quaterly',
	'2': 'biMonthly',
	B: 'biWeekly',
	C: 'continually',
	H: 'halfYearly',
	I: 'irregular'
};

// Determine if download frequency is lower than main frequency
const frequencyHierarchy: Record<string, number> = {
	allData: 0,
	daily: 1,
	weekly: 2,
	monthly: 3,
	yearly: 4,
	quaterly: 5,
	halfYearly: 6,
	biWeekly: 7,
	biMonthly: 8,
	continually: 9,
	irregular: 10
};

const downloadAuthorizationUser: any = {
	Materialien: [
		{ header: 'material_gruppen_id', key: 'material_gruppen_id', width: 30 },
		{ header: 'material_gruppe_name', key: 'material_gruppe_name', width: 30 },
		{ header: 'material_subgruppe_id', key: 'material_subgruppe_id', width: 30 },
		{ header: 'material_subgruppe_name', key: 'material_subgruppe_name', width: 30 },
		{ header: 'material_listen_id', key: 'material_listen_id', width: 30 },
		{ header: 'material_liste_name', key: 'material_liste_name', width: 50 },
		{ header: 'symbol', key: 'symbol', width: 20 },
		{ header: 'boerse', key: 'boerse', width: 20 },
		{ header: 'material_name', key: 'material_name', width: 50 },
		{ header: 'startdatum_material', key: 'startdatum_material', width: 30 },
		{ header: 'enddatum_material', key: 'enddatum_material', width: 30 },
		{ header: 'berechtigung_material', key: 'berechtigung_material', width: 30 },
		{ header: 'berechtigung_forecast', key: 'berechtigung_forecast', width: 30 },
		{ header: 'backpack_id', key: 'backpack_id', width: 30 },
		{ header: 'group_id', key: 'group_id', width: 30 },
		{ header: 'authorization_via', key: 'authorization_via', width: 30 }
	],
	News: [
		{ header: 'news_gruppe_id', key: 'news_gruppe_id', width: 30 },
		{ header: 'news_group_name', key: 'news_group_name', width: 30 },
		{ header: 'news_kategorie_id', key: 'news_kategorie_id', width: 30 },
		{ header: 'news_kategorie_name', key: 'news_kategorie_name', width: 30 },
		{ header: 'startdatum_news', key: 'startdatum_news', width: 30 },
		{ header: 'enddatum_news', key: 'enddatum_news', width: 30 },
		{ header: 'berechtigung_news', key: 'berechtigung_news', width: 30 },
		{ header: 'backpack_id', key: 'backpack_id', width: 30 },
		{ header: 'group_id', key: 'group_id', width: 30 },
		{ header: 'authorization_via', key: 'authorization_via', width: 30 }
	],
	Pdf: [
		{ header: 'pdf_box_id', key: 'pdf_box_id', width: 30 },
		{ header: 'pdf_box_name', key: 'pdf_box_name', width: 30 },
		{ header: 'pdf_gruppe_id', key: 'pdf_gruppe_id', width: 30 },
		{ header: 'pdf_gruppe_name', key: 'pdf_gruppe_name', width: 30 },
		{ header: 'pdfn_id', key: 'pdfn_id', width: 30 },
		{ header: 'pdf_title', key: 'pdf_title', width: 50 },
		{ header: 'startdatum_pdf', key: 'startdatum_pdf', width: 30 },
		{ header: 'enddatum_pdf', key: 'enddatum_pdf', width: 30 },
		{ header: 'berechtigung_pdf', key: 'berechtigung_pdf', width: 30 },
		{ header: 'backpack_id', key: 'backpack_id', width: 30 },
		{ header: 'group_id', key: 'group_id', width: 30 },
		{ header: 'authorization_via', key: 'authorization_via', width: 30 }
	],
	Forecast: [
		{ header: 'prognosen_box_id', key: 'prognosen_box_id', width: 30 },
		{ header: 'prognosen_box_name', key: 'prognosen_box_name', width: 30 },
		{ header: 'prognosen_gruppe_id', key: 'prognosen_group_id', width: 30 },
		{ header: 'prognosen_gruppe_name', key: 'prognosen_group_name', width: 30 },
		{ header: 'prognosen_id', key: 'prognosen_id', width: 30 },
		{ header: 'prognosen_titel', key: 'prognosen_titel', width: 50 },
		{ header: 'startdatum_prognose', key: 'startdatum_prognose', width: 30 },
		{ header: 'enddatum_prognose', key: 'enddatum_prognose', width: 20 },
		{ header: 'berechtigung_prognosen', key: 'berechtigung_prognosen', width: 30 },
		{ header: 'backpack_id', key: 'backpack_id', width: 30 },
		{ header: 'group_id', key: 'group_id', width: 30 },
		{ header: 'authorization_via', key: 'authorization_via', width: 30 }
	],
	Rucksack: [
		{ header: 'rucksack_id', key: 'rucksack_id', width: 30 },
		{ header: 'rucksack_name', key: 'rucksack_name', width: 30 },
		{ header: 'startdatum_backpack', key: 'startdatum_backpack', width: 30 },
		{ header: 'enddatum_backpack', key: 'enddatum_backpack', width: 30 },
		{ header: 'berechtigung_rucksack', key: 'berechtigung_rucksack', width: 30 }
	],
	Ausschreibungen: [
		{ header: 'berechtigung_ausschreibungen', key: 'berechtigung_ausschreibungen', width: 40 },
		{ header: 'enddatum_ausschreibungen', key: 'enddatum_ausschreibungen', width: 40 },
		{ header: 'startdatum_ausschreibungen', key: 'startdatum_ausschreibungen', width: 40 },
		{ header: 'backpack_id', key: 'backpack_id', width: 30 },
		{ header: 'group_id', key: 'group_id', width: 30 },
		{ header: 'authorization_via', key: 'authorization_via', width: 30 }
	]
};

const downloadAuthorizationBackpack: any = {
	Materialien: [
		{ header: 'material_gruppen_id', key: 'material_gruppen_id', width: 30 },
		{ header: 'material_gruppe_name', key: 'material_gruppe_name', width: 30 },
		{ header: 'material_subgruppe_id', key: 'material_subgruppe_id', width: 30 },
		{ header: 'material_subgruppe_name', key: 'material_subgruppe_name', width: 30 },
		{ header: 'material_listen_id', key: 'material_listen_id', width: 30 },
		{ header: 'material_liste_name', key: 'material_liste_name', width: 50 },
		{ header: 'symbol', key: 'symbol', width: 20 },
		{ header: 'boerse', key: 'boerse', width: 20 },
		{ header: 'material_name', key: 'material_name', width: 50 },
		{ header: 'startdatum_material', key: 'startdatum_material', width: 30 },
		{ header: 'enddatum_material', key: 'enddatum_material', width: 30 },
		{ header: 'berechtigung_material', key: 'berechtigung_material', width: 30 },
		{ header: 'berechtigung_forecast', key: 'berechtigung_forecast', width: 30 }
	],
	News: [
		{ header: 'news_gruppe_id', key: 'news_gruppe_id', width: 30 },
		{ header: 'news_group_name', key: 'news_group_name', width: 30 },
		{ header: 'news_kategorie_id', key: 'news_kategorie_id', width: 30 },
		{ header: 'news_kategorie_name', key: 'news_kategorie_name', width: 30 },
		{ header: 'startdatum_news', key: 'startdatum_news', width: 30 },
		{ header: 'enddatum_news', key: 'enddatum_news', width: 30 },
		{ header: 'berechtigung_news', key: 'berechtigung_news', width: 30 }
	],
	Pdf: [
		{ header: 'pdf_box_id', key: 'pdf_box_id', width: 30 },
		{ header: 'pdf_box_name', key: 'pdf_box_name', width: 30 },
		{ header: 'pdf_gruppe_id', key: 'pdf_gruppe_id', width: 30 },
		{ header: 'pdf_gruppe_name', key: 'pdf_gruppe_name', width: 30 },
		{ header: 'pdfn_id', key: 'pdfn_id', width: 30 },
		{ header: 'pdf_title', key: 'pdf_title', width: 50 },
		{ header: 'startdatum_pdf', key: 'startdatum_pdf', width: 30 },
		{ header: 'enddatum_pdf', key: 'enddatum_pdf', width: 30 },
		{ header: 'berechtigung_pdf', key: 'berechtigung_pdf', width: 30 }
	],
	Forecast: [
		{ header: 'prognosen_box_id', key: 'prognosen_box_id', width: 30 },
		{ header: 'prognosen_box_name', key: 'prognosen_box_name', width: 30 },
		{ header: 'prognosen_gruppe_id', key: 'prognosen_group_id', width: 30 },
		{ header: 'prognosen_gruppe_name', key: 'prognosen_group_name', width: 30 },
		{ header: 'prognosen_id', key: 'prognosen_id', width: 30 },
		{ header: 'prognosen_titel', key: 'prognosen_titel', width: 50 },
		{ header: 'startdatum_prognose', key: 'startdatum_prognose', width: 30 },
		{ header: 'enddatum_prognose', key: 'enddatum_prognose', width: 20 },
		{ header: 'berechtigung_prognosen', key: 'berechtigung_prognosen', width: 30 }
	],
	Rucksack: [
		{ header: 'rucksack_id', key: 'rucksack_id', width: 30 },
		{ header: 'rucksack_name', key: 'rucksack_name', width: 30 },
		{ header: 'startdatum_backpack', key: 'startdatum_backpack', width: 30 },
		{ header: 'enddatum_backpack', key: 'enddatum_backpack', width: 30 },
		{ header: 'berechtigung_rucksack', key: 'berechtigung_rucksack', width: 30 }
	],
	Ausschreibungen: [
		{ header: 'berechtigung_ausschreibungen', key: 'berechtigung_ausschreibungen', width: 40 },
		{ header: 'enddatum_ausschreibungen', key: 'enddatum_ausschreibungen', width: 40 },
		{ header: 'startdatum_ausschreibungen', key: 'startdatum_ausschreibungen', width: 40 }
	]
};

const downloadAdminDataMaterial: any = {
	Materialien: [
		{ header: 'Benutzer ID', key: 'Benutzer ID', width: 15 },
		{ header: 'Status', key: 'Status', width: 20 },
		{ header: 'Email', key: 'Email', width: 40 },
		{ header: 'Kommentar', key: 'Kommentar', width: 70 },
		{ header: 'Anrede', key: 'Anrede', width: 15 },
		{ header: 'Vorname', key: 'Vorname', width: 20 },
		{ header: 'Nachname', key: 'Nachname', width: 20 },
		{ header: 'Firma', key: 'Firma', width: 50 },
		{ header: 'Sprache', key: 'Sprache', width: 15 },
		{ header: 'Whitelabel', key: 'Whitelabel', width: 20 },
		{ header: 'API Key Aktiv', key: 'API Key Aktiv', width: 20 },
		{ header: 'Group', key: 'Group', width: 20 },
		{ header: 'Last Login', key: 'Last Login', width: 30 },
		{ header: 'startdatum_material', key: 'startdatum_material', width: 30 },
		{ header: 'enddatum_material', key: 'enddatum_material', width: 30 },
		{ header: 'berechtigung_material', key: 'berechtigung_material', width: 30 },
		{ header: 'berechtigung_forecast', key: 'berechtigung_forecast', width: 30 },
		{ header: 'backpack_id', key: 'backpack_id', width: 30 },
		{ header: 'group_id', key: 'group_id', width: 30 },
		{ header: 'authorization_via', key: 'authorization_via', width: 30 }
	],
	Rucksäcke: [
		{ header: 'backpack_id', key: 'backpack_id', width: 15 },
		{ header: 'backpack_name', key: 'backpack_name', width: 50 },
		{ header: 'startdatum_material', key: 'startdatum_material', width: 20 },
		{ header: 'enddatum_material', key: 'enddatum_material', width: 20 },
		{ header: 'berechtigung_material', key: 'berechtigung_material', width: 30 },
		{ header: 'berechtigung_forecast', key: 'berechtigung_forecast', width: 30 }
	]
};

const courseGroupMapper: Record<string, string> = {
	intraday: 'D',
	daily: 'D',
	weekly: 'W',
	monthly: 'M',
	quaterly: 'Q',
	biMonthly: '2',
	biWeekly: 'B',
	continually: 'C',
	halfYearly: 'H',
	irregular: 'I'
};

export {
	adminAdvancedSearchCsvHeaders,
	adminAuthBackpackNavbar,
	adminAuthUserNavbar,
	adminListEntriesHeader,
	adminMasterDataHeaders,
	adminMatrialForecastExcelHeaders,
	adminMatrialIntradayHeaders,
	advantage,
	alertCountKeys,
	alertIcon,
	API_CONFIG,
	apiMasterDataCsvHeaders,
	browserLanguage,
	chartColors,
	CHARTMAPPER,
	chartSettingColor,
	chartSettingColorPallet,
	chartUpdateFrequencyMapper,
	checkBackpackGroupData,
	checkExpiredDate,
	checkMaterialData,
	COLOR_FIELDS,
	colorPallet,
	compareChartSettingColor,
	costModelTableHeader,
	courseDateRange,
	courseTableHeading,
	createOption,
	// csvHeaders,
	customCsvHeaders,
	DATE_FORMAT_MAPPER,
	DATE_PLACEHOLDER_MAPPER,
	DateRangeMapper,
	defArray,
	downloadAdminMasterDataHeaders,
	downloadCountriesAndRegions,
	downloadCurrenciesHeader,
	downloadHeader,
	downloadMaterialGroupHeaders,
	downloadNotations,
	downloadTenadersCountriesHeaders,
	downloadUnitsHeaders,
	durationOptions,
	englishLocale,
	ENVIRONMENT,
	FILE_SIZE,
	firstLevelBreadcrumbs,
	forecastBackpackMasterDataHeaders,
	germanLocale,
	getDifferenceDaysForOneYear,
	getErrorMessage,
	getFileUploadFolder,
	getUrl,
	groupUserListHeader,
	IMAGE_EXPORT_BUTTON_ARRAY,
	ImageLink,
	kebabMenu,
	materialDescription,
	materialUserCourseTableHeading,
	matfoxxJokesListHeaders,
	matfoxxOffersListHeaders,
	memoizedStyles,
	mouseEdgeAppearance,
	multiReactSelectStyles,
	newsBackpackMasterDataHeaders,
	newsData,
	newsDataDescription,
	newsListHeaders,
	pageOptions,
	passwordRegex,
	pdfModuleBackpackMasterDataHeaders,
	PER_PAGE,
	protocolListHeaders,
	radioButtonArray,
	reactSelectStyles,
	statisticsDateRange,
	// responsiveTableHEading,
	STROKESCOLORS,
	SUPPORTED_FORMATS,
	tenderData,
	tenderDescription,
	timeMapper,
	UploadFileName,
	URL_REGEX,
	userListBackpackMasterDataHeaders,
	whiteSpceRegex,
	WINDOW_WIDTH,
	columnHeading,
	centerTextDesign,
	chartType,
	chartMapper,
	spanDropDownOptions,
	ChartTypeOption,
	decimalSeparatorOptions,
	languageOptions,
	apiMasterDataNewsCsvHeaders,
	barSpanDropDown,
	FrequencyMapper,
	frequencyHierarchy,
	downloadAdminDataMaterial,
	downloadAuthorizationUser,
	downloadAuthorizationBackpack,
	AuthorizationFileName,
	courseGroupMapper,
	downloadUserLogins
};
